import React from "react";

export default function Footer({ t }) {
  return (
    <footer className="footer">
      <div className="footer-contact">{t.contact}</div>

      <div className="footer-partners">
        {t.partners}
      </div>

      <div className="footer-copyright">
        © 2026 Henson Systems
      </div>
    </footer>
  );
}
